import { Box } from "@chakra-ui/react";
import { BoxList } from "../../../components/BoxList";
import { CardDescontoExclusivoVertical } from "../../../components/CardDescontoExclusivo/Vertical";
import { CardOfertaVertical } from "../../../components/CardOferta/Vertical";
import CardCashbackVertical from "../../../components/CardCashback/Vertical";
import { CardVerMais } from "../../../components/CardVerMais";
import { usePersonalizacao } from "../../../context/usePersonalizacao";
import { useRecomendacao } from "../../../context/useRecomendacao";
import { formatRecomendacao, intercale } from "../../../utils";
import { LojaButton } from "../../../components/LojaButton";

export function CarrosselPreview() {
  const { recomendacao, viewDescricao, destaquesLabel, loja } =
    useRecomendacao();

  const {
    personalizacao: { card, guiaofertas },
  } = usePersonalizacao();

  let filteredRecomendacao = [];

  if (guiaofertas?.hasDestaques) {
    filteredRecomendacao = recomendacao.filter(
      (data) =>
        data.id_classificacao_topete === "1" ||
        data.id_classificacao_topete === "3"
    );

    if (filteredRecomendacao.length === 0) {
      filteredRecomendacao = recomendacao;
    }
  } else {
    filteredRecomendacao = recomendacao;
  }

  const { ofertas, dinheiroDeVolta, descontoExclusivo } =
    formatRecomendacao(filteredRecomendacao);

  const produtos = intercale(descontoExclusivo, dinheiroDeVolta, ofertas);

  return (
    <Box maxWidth="900px" margin="0 auto" background="white" overflow="hidden">
      <Box marginX="1rem" mt="0.5rem" justifyContent="center" mr="2rem">
        <LojaButton loja={loja.nomeLoja} />
      </Box>
      {produtos.length > 0 && (
        <Box w="100%" id="destaque-boxlist">
          <BoxList
            isVisibleVermais={true}
            title={destaquesLabel}
            bgcolorTitle={card?.bgcortitle}
            textcolorTitle={card?.cortextotitle}
            isFeed={true}
          >
            {produtos.slice(0, 10).map((data, index) => (
              <Box flex="0 0 auto" height="375px" key={index}>
                {data.idtiporecomendacao === "1" && (
                  <CardDescontoExclusivoVertical
                    key={data.idoferta}
                    props={data}
                    onClickCard={
                      !data.linkproduto
                        ? () => {
                            window.ReactNativeWebView.postMessage(
                              JSON.stringify({
                                title: data.nomeoferta.slice(0, 30),
                                url: data.linkproduto,
                                idoferta: data.idoferta,
                                idtiporecomendacao: "1",
                                redirect: false,
                              })
                            );
                            viewDescricao(data);
                          }
                        : () => {
                            window.ReactNativeWebView.postMessage(
                              JSON.stringify({
                                title: data.nomeoferta.slice(0, 30),
                                url: data.linkproduto,
                                redirect: false,
                              })
                            );
                            viewDescricao(data);
                          }
                    }
                  />
                )}
                {data.idtiporecomendacao === "2" && (
                  <CardOfertaVertical
                    key={data.idoferta}
                    props={data}
                    onClickCard={
                      !data.linkproduto
                        ? () => {
                            window.ReactNativeWebView.postMessage(
                              JSON.stringify({
                                title: data.nomeoferta.slice(0, 30),
                                url: data.linkproduto,
                                idoferta: data.idoferta,
                                idtiporecomendacao: "2",
                                redirect: false,
                              })
                            );
                            viewDescricao(data);
                          }
                        : () => {
                            window.ReactNativeWebView.postMessage(
                              JSON.stringify({
                                title: data.nomeoferta.slice(0, 30),
                                url: data.linkproduto,
                                redirect: false,
                              })
                            );
                            viewDescricao(data);
                          }
                    }
                  />
                )}
                {data.idtiporecomendacao === "3" && (
                  <CardCashbackVertical
                    key={data.idoferta}
                    props={data}
                    onClickCard={
                      !data.linkproduto
                        ? () => {
                            window.ReactNativeWebView.postMessage(
                              JSON.stringify({
                                title: data.nomeoferta.slice(0, 30),
                                url: data.linkproduto,
                                idoferta: data.idoferta,
                                idtiporecomendacao: "3",
                                redirect: false,
                              })
                            );
                            viewDescricao(data);
                          }
                        : () => {
                            window.ReactNativeWebView.postMessage(
                              JSON.stringify({
                                title: data.nomeoferta.slice(0, 30),
                                url: data.linkproduto,
                                redirect: false,
                              })
                            );
                            viewDescricao(data);
                          }
                    }
                  />
                )}
              </Box>
            ))}
            <Box marginLeft="0.5">
            <CardVerMais
              onClickVerMais={() => {
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({
                    redirect: true,
                  })
                );
              }}
            />
            </Box>
          </BoxList>
        </Box>
      )}
    </Box>
  );
}
